/**
 * @module components\ghInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";
import InputBase from "./inputBase";
import CheckInput from "./checkInput/checkInput";
import TextInput from "./textInput/textInput";
import DateInput from "./dateInput/dateInput";
import IconInput from "./iconInput/iconInput";
import ImageInput from "./imageInput/imageInput";
import NumberInput from "./numberInput/numberInput";
import TextAreaInput from "./textAreaInput/textAreaInput";
import SelectionInput from "./selectionInput/selectionInput";
import RangeInput from "./rangeInput/rangeInput";
import QrcodeInput from './qrcodeInput/qrcodeInput';
import BarcodeInput from './barcodeInput/barcodeInput';

@Component({
  components: {
    "check-input": CheckInput,
    "number-input": NumberInput,
    "date-input": DateInput,
    "icon-input": IconInput,
    "image-input": ImageInput,
    "text-input": TextInput,
    "textarea-Input": TextAreaInput,
    "selection-input": SelectionInput,
    "range-input": RangeInput,
    "barcode-input":BarcodeInput,
    "qrcode-input":QrcodeInput
  }
})
export default class GhInput extends InputBase {
  private map = {
    "boolean-input": "check-input",
    "number-input": "number-input",
    "date-input": "date-input",
    "icon-input": "icon-input",
    "image-input": "image-input",
    "string-input": "text-input",
    "textarea-input": "textarea-Input",
    "selection-input": "selection-input",
    "range-input": "range-input",
    "barcode-input":"barcode-input",
    "qrcode-input":"qrcode-input"
  };

  private get component() {
    let com = "text-input";
    if (this.prop.type) {
      let key = this.prop.type + "-input";
      let input = this.map[key];
      if (input) {
        com = input;
      }
    }
    return com;
  }
}
